import React from 'react';
import './BodySection.css';
import { FaGraduationCap, FaFileAlt, FaDownload, FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import STUDENT_PERFORMA_SCHOLARSHIP from "../bodysection/pdf/164813022248.pdf";
import STUDENT_SCHOLARSHIP_AFFIDAVIT from "./pdf/Affidavit___Student_-2023-1.docx"
import Application_For_Applying_Job from "./pdf/165509642339.pdf"

const BodySection = () => {
  return (
    <section className="admission-section">
      {/* Decorative Elements */}
      <div className="bg-decoration">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>

      <div className="container">
        {/* Header Section */}
        <div className="section-header" data-aos="fade-up">
          <span className="badge">Admissions 2026</span>
          <h1 className="main-title">
            <span className="title-blue">Begin Your Journey</span>
            <span className="title-yellow">With Us</span>
          </h1>
          <p className="subtitle">
            Admissions Open for Diploma, UG & PG Courses for the Academic Year 2026-27
          </p>
        </div>

        {/* Cards Grid */}
        <div className="cards-grid">
          {/* Quick Info Cards */}
          <div className="info-card" data-aos="fade-up" data-aos-delay="100">
            <div className="card-icon blue">
              <FaGraduationCap />
            </div>
            <h3>Programs Offered</h3>
            <p>Diploma, B.Tech, M.Tech & MBA programs with AICTE approval</p>
            <a href="/courses" className="card-link">
              View Programs <FaArrowRight />
            </a>
          </div>

          <div className="info-card" data-aos="fade-up" data-aos-delay="200">
            <div className="card-icon yellow">
              <FaCalendarAlt />
            </div>
            <h3>Important Dates</h3>
            <p>Application Deadline: March 31, 2026<br/>Entrance Test: April 15, 2026</p>
            <a href="/important-dates" className="card-link">
              View Schedule <FaArrowRight />
            </a>
          </div>

          <div className="info-card" data-aos="fade-up" data-aos-delay="300">
            <div className="card-icon blue">
              <FaFileAlt />
            </div>
            <h3>Scholarships</h3>
            <p>Merit-based and need-based scholarships available for deserving students</p>
            <a href="/scholarship" className="card-link">
              Check Eligibility <FaArrowRight />
            </a>
          </div>
        </div>

        {/* Application Forms Section */}
        <div className="forms-section" data-aos="fade-up">
          <h2 className="section-title">
            <span className="title-yellow">Download</span>
            <span className="title-blue">Application Forms</span>
          </h2>

          <div className="forms-grid">
            <a 
              href={Application_For_Applying_Job} 
              download="Application_For_Applying_Job"
              className="form-card"
              data-aos="fade-up" data-aos-delay="100"
            >
              <div className="form-icon">
                <FaDownload />
              </div>
              <div className="form-content">
                <h3>Job Application Form</h3>
                <p>For teaching and non-teaching positions</p>
                <span className="download-btn">
                  Download <FaArrowRight />
                </span>
              </div>
            </a>

            <a 
              href={STUDENT_SCHOLARSHIP_AFFIDAVIT} 
              download="STUDENT_SCHOLARSHIP_AFFIDAVIT"
              className="form-card"
              data-aos="fade-up" data-aos-delay="200"
            >
              <div className="form-icon">
                <FaDownload />
              </div>
              <div className="form-content">
                <h3>Scholarship Affidavit</h3>
                <p>Student scholarship affidavit form</p>
                <span className="download-btn">
                  Download <FaArrowRight />
                </span>
              </div>
            </a>

            <a 
              href={STUDENT_PERFORMA_SCHOLARSHIP} 
              download="STUDENT_PERFORMA_SCHOLARSHIP"
              className="form-card"
              data-aos="fade-up" data-aos-delay="300"
            >
              <div className="form-icon">
                <FaDownload />
              </div>
              <div className="form-content">
                <h3>Scholarship Performa</h3>
                <p>Student scholarship performa form</p>
                <span className="download-btn">
                  Download <FaArrowRight />
                </span>
              </div>
            </a>
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section" data-aos="fade-up">
          <div className="cta-content">
            <h2>Ready to Start Your Journey?</h2>
            <p>Apply now and take the first step towards a successful career</p>
            <div className="cta-buttons">
              <a href="/admission" className="btn btn-primary">
                Apply Online
              </a>
              <a href="/contact" className="btn btn-secondary">
                Contact Counselor
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BodySection;